module.exports = __webpack_public_path__ + "img/795b3f5.jpg";